import { trackingAttributesMapping } from '@tracking/events/engagement';
import { TUserShortcut } from '@vNext/models/PublicationConfig/HomePageConfig';

const { manageDeliveries } = CONFIG.subPagesPaths;
const { basePath } = CONFIG;

const shortcutsLinks = {
    getSettings: link => ({
        id: 'settings',
        iconName: 'settings',
        title: 'vNext.homePage.shortcuts.settings.title',
        description: 'vNext.homePage.shortcuts.settings.description',
        link,
    }),
    getFAQ: link => ({
        id: 'faq',
        iconName: 'forum',
        title: 'vNext.homePage.shortcuts.faq.title',
        description: 'vNext.homePage.shortcuts.faq.description',
        link,
    }),
    getNewsletter: link => ({
        id: 'newsletter',
        iconName: 'mail',
        title: 'vNext.homePage.shortcuts.newsletter.title',
        description: 'vNext.homePage.shortcuts.newsletter.description',
        link,
    }),
    getPrivacySettings: link => ({
        id: 'privacySettings',
        iconName: 'security',
        title: 'vNext.homePage.shortcuts.privacySettings.title',
        description: 'vNext.homePage.shortcuts.privacySettings.description',
        link,
    }),
    getCustomerSupport: link => ({
        id: 'customerSupport',
        iconName: 'supportAgent',
        title: 'vNext.homePage.shortcuts.customerSupport.title',
        description: 'vNext.homePage.shortcuts.customerSupport.description',
        link,
    }),
    getPodcasts: link => ({
        id: 'podcasts',
        iconName: 'headphones',
        title: 'vNext.homePage.shortcuts.podcasts.title',
        description: 'vNext.homePage.shortcuts.podcasts.description',
        link,
    }),
    getContact: link => ({
        id: 'contact',
        iconName: 'mailOut',
        title: 'vNext.homePage.shortcuts.contact.title',
        description: 'vNext.homePage.shortcuts.contact.description',
        link,
    }),
    getRewards: link => ({
        id: 'rewards',
        iconName: 'loyaltyTag',
        title: 'vNext.homePage.shortcuts.rewards.title',
        description: 'vNext.homePage.shortcuts.rewards.description',
        link,
    }),
    getRewardCard: link => ({
        id: 'rewardCard',
        iconName: 'rewardCard',
        title: 'vNext.homePage.shortcuts.rewardCard.title',
        description: 'vNext.homePage.shortcuts.rewardCard.description',
        link,
    }),
    getMagazines: link => ({
        id: 'magazines',
        iconName: 'magazine',
        title: 'vNext.homePage.shortcuts.magazines.title',
        description: 'vNext.homePage.shortcuts.magazines.description',
        link,
    }),
    getSubscriptionTerms: link => ({
        id: 'subscriptionTerms',
        iconName: 'contract',
        title: 'vNext.homePage.shortcuts.subscriptionTerms.title',
        description: 'vNext.homePage.shortcuts.subscriptionTerms.description',
        link,
    }),
} satisfies Record<string, (link: string) => TUserShortcut>;

const homeShortcutsActions = {
    getPaymentHistory: () => ({
        id: 'paymentHistory',
        iconName: 'card',
        title: 'vNext.homePage.shortcuts.paymentHistory.title',
        description: 'vNext.homePage.shortcuts.paymentHistory.description',
    }),
} satisfies Record<string, () => TUserShortcut>;

export const homeShortcuts = {
    ...shortcutsLinks,
    ...homeShortcutsActions,
};

const subscriptionShortcutsLinks = {
    getPrivacySettings: shortcutsLinks.getPrivacySettings,
    getSubscriptionTerms: shortcutsLinks.getSubscriptionTerms,
} satisfies Record<string, (link: string) => TUserShortcut>;

export const subscriptionShortcuts = {
    ...subscriptionShortcutsLinks,
};

const deliveryPageManageOptionsPrefix = 'vNext.delivery.components.manageDeliveries.options';
export const manageDeliveriesTiles = {
    deliveryIssues: {
        id: 'deliveryIssues',
        title: `${deliveryPageManageOptionsPrefix}.deliveryIssues.title`,
        description: `${deliveryPageManageOptionsPrefix}.deliveryIssues.description`,
        path: `${basePath}${manageDeliveries.base}${manageDeliveries.submitComplaint}`,
        trackingId: trackingAttributesMapping.mypage.deliveries.submitComplaint,
    },
    temporaryAddressChange: {
        id: 'changeTemporaryAddress',
        title: `${deliveryPageManageOptionsPrefix}.changeTemporaryAddress.title`,
        description: `${deliveryPageManageOptionsPrefix}.changeTemporaryAddress.description`,
        path: `${basePath}${manageDeliveries.base}${manageDeliveries.temporaryAddressChange}`,
        trackingId: trackingAttributesMapping.mypage.deliveries.changeTemporaryDelivery,
    },
    pauseDelivery: {
        id: 'pauseDelivery',
        title: `${deliveryPageManageOptionsPrefix}.pauseDelivery.title`,
        description: `${deliveryPageManageOptionsPrefix}.pauseDelivery.description`,
        path: `${basePath}${manageDeliveries.base}${manageDeliveries.pauseDelivery}`,
        trackingId: trackingAttributesMapping.mypage.deliveries.changeTemporaryPauseDelivery,
    },
    permanentAddressChange: {
        id: 'changePermanentAddress',
        title: `${deliveryPageManageOptionsPrefix}.changePermanentAddress.title`,
        description: `${deliveryPageManageOptionsPrefix}.changePermanentAddress.description`,
        path: `${basePath}${manageDeliveries.base}${manageDeliveries.permanentAddressChange}`,
        trackingId: trackingAttributesMapping.mypage.deliveries.changePermanentDelivery,
    },
};
